import { useEffect, useReducer } from 'react';
import reducer from './reducer';
import getActions from './getActions';
import { ITopRatingAgenciesState } from '@/creditflowresearch/application/League/interfaces';
import { useLeagueTableFiltersContext } from '@/creditflowresearch/application/League/Table/LeagueTableFiltersContext';

interface IProps {
  topRatingAgenciesInitialState: ITopRatingAgenciesState,
}

export default ({ topRatingAgenciesInitialState }:IProps) => {
  const [state, dispatch] = useReducer(reducer, topRatingAgenciesInitialState);
  const { page, perPage } = state;
  const { state: filtersState } = useLeagueTableFiltersContext();
  const selectedPeriod = filtersState.periods.topRatingAgencies.selected;

  const actions = getActions({ page, perPage, selectedPeriod }, dispatch);

  useEffect(() => {
    const { data: collection, totalCount } = topRatingAgenciesInitialState;

    actions.setTopRatingAgenciesData({ collection, totalCount });
  }, [topRatingAgenciesInitialState]);

  return {
    state,
    ...actions,
  };
};
